export const LOCAL_STORE_PARTNER = "partnerId";
export const LOCAL_STORE_SEARCH_PARTNERS = "searchPartners";
